import isString from 'lodash.isstring';
import mapValues from 'lodash.mapvalues';
import * as navTypes from '../actions/nav.types';
import NAV_KEY_MAP_TO_ACTIONS, { URL_OFF_SITE } from '../actions/navkey.types';

// const log = debug('huddle:store:reducers:nav');

const API_MENU_KEYS = {
  header: 'huddle-my-huddle',
  primary: 'huddle-primary-menu',
  quickLinks: 'huddle-quick-links',
  footer: 'huddle-footer-menu',
  bottom: 'footer',
};

const INITIAL_NAV = mapValues(API_MENU_KEYS, () => []);

const keyEnsureFormat = key =>
  (!key ? key : key.toUpperCase().replace(/[\s-]/g, '_'));

const TITLE_HINT_RE = /\s*\(.*\)/;
const keyFromTitle = title =>
  title.toUpperCase().replace(TITLE_HINT_RE, '').trim().replace(/[\s-]/g, '_');

const mapAction = key => {
  const action = NAV_KEY_MAP_TO_ACTIONS[key];
  if (!key || !action) {
    return undefined;
  }
  if (isString(action)) {
    return { type: action };
  }
  return action;
};

const isExternal = url => url && !!url.length;
const externalPathFromKey = key =>
  (!key ? '' : key.toLowerCase().replace(/[\s_]/g, '-'));

const restrictedRoutes = [];

const transformNavItem = ({ title, url, key, children, restricted }) => {
  // CURRENTLY: work around b/c no keys are set coming from API
  const useKey = keyEnsureFormat(key) || keyFromTitle(title);
  const item = {
    label: title,
    key: useKey,
    url,
    restricted,
  };
  const action = mapAction(keyEnsureFormat(key));

  if (action) {
    // (Legacy, safe to remove) This was being used for determing if a page is restricted to unsubscribed users
    // restrictedRoutes.push({
    //   type: action.type,
    //   restricted,
    // });

    // TODO: remove this hack when the /WP/Nav endpoint is cleaned up
    if (action.type === URL_OFF_SITE) {
      if (!item.url) {
        item.url = `http://thehuddle.com/${externalPathFromKey(useKey)}`;
      }
    } else {
      item.action = action;
      delete item.url;
    }
  }
  // If a new key is added without being mapped, fallback to '#' for now
  // TODO: Implement a 404 page?
  if (!item.action && !item.url) {
    item.url = '#';
  }
  if (children && children.length) {
    item.children = transformNav(children); // eslint-disable-line no-use-before-define
  }
  item.isExternal = isExternal(item.url);
  return item;
};

const transformNav = items => {
  if (!items || !items.length) {
    return [];
  }
  return items.map(transformNavItem);
};

const navLoading = state => ({
  ...state,
  loading: true,
  error: null,
  restricted: null,
});

const navError = (state, { payload: { error } }) => ({
  ...state,
  loading: false,
  error,
  restricted: null,
});

const navData = ({ nav }) => {
  // CURRENTLY: the API will return the entire set so replace everything
  const newNav = mapValues(API_MENU_KEYS, apiKey => transformNav(nav[apiKey]));
  return {
    ...newNav,
    loading: false,
    error: null,
    restricted: restrictedRoutes,
  };
};

const navReducer = (state = INITIAL_NAV, action = {}) => {
  const { type, payload, error } = action;
  switch (type) {
    case navTypes.NAV_FETCH:
      return navLoading(state);
    case navTypes.NAV_RECEIVED:
      return navData(payload);
    case navTypes.NAV_ERROR:
      return navError(state, error);
    default:
      return state;
  }
};

export default navReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/nav.js